/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
import { color } from 'native-base/lib/typescript/theme/styled-system';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  footer: {
    paddingHorizontal: TwTheme.values.spaces.pageHorizontal,
    paddingVertical: TwTheme.values.spaces['4']
  },
  container: {},
  headerContainer: {
    padding: theme.spaces[3],
    backgroundColor: '#FFFFFF'
    //TODO:注意背景色
  },
  userAvatar: {
    backgroundColor: '#4F46E5'
  },
  userContainer: {
    alignItems: 'center'
  },
  avatarDesc: {
    ...theme.textSizes.md,
    color: '#FAFAFA'
  },
  userInfo: {},
  userName: {
    ...theme.textSizes.lg
  },
  phoneContainerr: {
    alignItems: 'center'
  },
  userPhone: {
    color: theme.textColors.forth,
    ...theme.textSizes.xs
  },
  orderContainer: {
    flex: 1
  },
  iconButton: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  // 内容区
  content: {
    paddingHorizontal: theme.spaces[4]
  },
  contentItem: {
    borderRadius: theme.radius.md
  },
  rightDesc: {
    ...theme.textSizes.sm,
    color: theme.textColors.forth
  }
});
